import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { ReportAnIssueBody } from "@shared-kernel/application/ports/shared/shared-repository";

export const reportIssue = createAsyncThunk<void, ReportAnIssueBody, { extra: Partial<Dependencies> }>(
  "users/reportIssue",
  async (body: ReportAnIssueBody, { extra: { sharedRepository } }) => {
    return sharedRepository!.reportIssue(body);
  },
);
